import { TabletIcon } from '@shared/components/icons/svg-icon.tsx';
import { ScreenOrientationEnum } from '@modules/digital-signage/model/group-settings.model.ts';

export const SCREEN_ORIENTATION_TABS = [
  {
    label: 'portrait',
    value: ScreenOrientationEnum.Portrait,
    icon: <TabletIcon />
  },
  {
    label: 'landscape',
    value: ScreenOrientationEnum.Landscape,
    icon: <TabletIcon style={{ transform: 'rotate(90deg)' }} />
  }
];
